import { Flex } from '@/components';
import type { FC } from 'react';
import { WorkflowTemplateFormDrawer } from './WorkflowTemplateFormDrawer';
import { WorkflowTemplateListTable } from './WorkflowTemplateListTable';
import { WorkflowTemplateSearchAccordion } from './search-accordion/WorkflowTemplateSearchAccordion';

export const WorkflowTemplateListContent: FC = () => {
  return (
    <>
      <Flex vertical gap={16}>
        <WorkflowTemplateSearchAccordion />
        <WorkflowTemplateListTable />
      </Flex>
      <WorkflowTemplateFormDrawer />
    </>
  );
};
